<script>
import axios from "axios";
import Card from "../components/ui/Card.vue";
import TitlePage from "../components/layout/TitlePage.vue";
import CantidadDespachos from "../components/graficos/CantidadDespachos.vue";
import DocumentosGrafico from "../components/graficos/DocumentosGrafico.vue";
import Aforo from "../components/graficos/Aforo.vue";
import VistosBuenos from "../components/graficos/VistosBuenos.vue";
import FechaEta from "../components/graficos/FechaEta.vue";

import EstatusDespacho from "../components/graficos/EstatusDespacho.vue";

import { mapGetters, mapActions } from "vuex";
import DocumentoPorsentajeEstado from "../components/graficos/DocumentoPorsentajeEstado.vue";
import TipoVistosBuenos from "../components/graficos/TipoVistosBuenos.vue";
import TipoAforos from "../components/graficos/TipoAforos.vue";
import DespachosPorPedidor from "../components/graficos/DespachosPorPedidor.vue";
import DespachosPorAduana from "../components/graficos/DespachosPorAduana.vue";

import TotalBlueBar from "../components/graficos/TotalBlueBar.vue";

export default {
  components: {
    Card,
    TitlePage,
    CantidadDespachos,
    DocumentosGrafico,
    Aforo,
    VistosBuenos,
    FechaEta,
    EstatusDespacho,
    DocumentoPorsentajeEstado,
    TipoVistosBuenos,
    TipoAforos,
    DespachosPorPedidor,
    DespachosPorAduana,
    TotalBlueBar,
  },
  name: "Dashboard",

  data() {
    return {
      //Cantidad Despachos
      total: [],
      fechas: [],
      importacion: [],
      exportacion: [],

      aforos: undefined,
      vistos_buenos: undefined,
      eta: undefined,
      aforos_tipos: undefined,

      total_documentos: undefined,

      vistos_buenos_instituciones: undefined,

      despachos_por_pedidor: undefined,
      despachos_por_aduana: undefined,

      total_despachos: null,
      despachos_pendientes: null,
      despachos_parcial: null,
      despachos_total: null,

      vistos_buenos_pendientes: null,
      vistos_buenos_realizados: null,

      fecha_eta_vencida: null,
      fecha_eta_por_cumplir: null,

      documentos_completos: null,
      documentos_faltantes: null,

      p_estados: {
        pendientes: undefined,
        presentados: undefined,
        retirados: undefined,
        legalizados: undefined,
      },
      //filtros activo
      filtros: {
        siete_activo: true,
        mes_activo: false,
        ano_activo: false,
      },

      isBusy: false,
    };
  },
  computed: {
    ...mapGetters({
      filtro: "filtros/filtro",
    }),
  },
  async mounted() {
    this.cambiarFecha(3);
    await this.getDashboard();
  },
  methods: {
    ...mapActions({
      cambiarFiltro: "filtros/cambiarFiltro",
      cambiarFecha: "filtros/cambiarFecha",
      signOutAction: "auth/signOut",
    }),
    //Cambio Activo
    async cambioActivo(valor, filtro) {
      for (var [key, value] of Object.entries(this.filtros)) {
        if (key == filtro) this.filtros[key] = true;
        else this.filtros[key] = false;
      }
      this.cambiarFecha(valor);
      await this.getDashboard(valor);
    },
    toggleBusy() {
      this.isBusy = !this.isBusy;
    },

    irADespachos(filtro) {
      this.cambiarFiltro(filtro);
      this.$router.push({
        name: "Despachos",
        query: { dashboardFilter: true },
      });
    },
    irAforos(filtro) {
      this.cambiarFiltro(filtro);
      this.$router.push({ name: "aforos", query: { dashboardFilter: true } });
    },
    irVistosBuenos(filtro) {
      this.cambiarFiltro(filtro);
      this.$router.push({
        name: "vistos-buenos",
        query: { dashboardFilter: true },
      });
    },

    //Get Dashboard
    async getDashboard(filtro = 3) {
      this.fechas = [];
      this.toggleBusy();

      try {
        const { data } = await axios.get(`api/admin/dashboard/${filtro}`);

        if (data) {
          //Aforo
          this.aforos = { ...data?.aforos };
          this.aforos_tipos = [...data?.aforos_tipo_inspecciones];

          //Vistos Buenos
          this.vistos_buenos = { ...data?.vistos_buenos };

          this.vistos_buenos_instituciones = {
            ...data?.vistos_buenos_instituciones,
          };

          this.total_documentos = data?.total_documentos;

          this.despachos_por_pedidor = [...data?.despachos_por_pedidor];
          this.despachos_por_aduana = [...data?.despachos_por_aduana];
          //ETA
          this.eta = { ...data?.eta };
          //this.fecha_eta_vencida = data?.eta_vencida;
          //this.fecha_eta_por_cumplir = data?.vencimiento_eta;

          //ESTADO CARGA
          this.despachos_parcial = data?.parcial;
          this.despachos_pendientes = data?.pendientes;
          this.despachos_total = data?.total;

          //TOTAL DESPACHOS
          this.total_despachos = data?.total_despachos;

          //DOCUMENTOS
          this.documentos_completos = data?.documentos?.completos?.total;
          this.documentos_faltantes = data?.documentos?.faltantes?.total;

          //DOCUMENTOS
          this.fechas = data?.cantidad_despachos?.fechas;
          this.total = data?.cantidad_despachos?.total;
          this.importacion = data?.cantidad_despachos?.importacion;
          this.exportacion = data?.cantidad_despachos?.exportacion;

          const p_estados = { ...data?.total_por_estados_despacho };

          const total =
            p_estados?.presentados +
            p_estados?.pendientes +
            p_estados?.legalizados +
            p_estados?.retirados;

          this.p_estados.pendientes = p_estados.pendientes
            ? +((p_estados?.pendientes * 100) / total).toFixed(2)
            : 0;

          this.p_estados.presentados = p_estados?.presentados
            ? +((p_estados?.presentados * 100) / total).toFixed(2)
            : 0;
          this.p_estados.legalizados = p_estados.legalizados
            ? +((p_estados?.legalizados * 100) / total).toFixed(2)
            : 0;
          this.p_estados.retirados = p_estados.retirados
            ? +((p_estados?.retirados * 100) / total).toFixed(2)
            : 0;

          this.toggleBusy();
        }
      } catch (err) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Hubo un problema al obtener los datos del dashboard",
        });
        console.error(err);
      }
    },
  },
};
</script>

<template>
  <div>
    <div class="flex flex-col pt-4 gap-8">
      <div
        class="flex flex-row text-center justify-between w-full gap-1 border-b border-[#101010]"
      >
        <span class="text-xs font-semibold uppercase">Dashboard</span>
        <div class="flex flex-row gap-2 items-center mb-1">
          <button
            class="btn-dashboard"
            v-bind:class="{ 'filtro-activo': filtros.siete_activo }"
            @click="cambioActivo(3, 'siete_activo')"
          >
            7 Días
          </button>
          <button
            class="btn-dashboard"
            v-bind:class="{ 'filtro-activo': filtros.mes_activo }"
            @click="cambioActivo(2, 'mes_activo')"
          >
            1 Mes
          </button>
          <button
            class="btn-dashboard"
            v-bind:class="{ 'filtro-activo': filtros.ano_activo }"
            @click="cambioActivo(1, 'ano_activo')"
          >
            1 Año
          </button>
        </div>
      </div>

      <div class="grid grid-cols-1 lg:grid-cols-2 w-full gap-8">
        <div class="lg:col-span-2 grid grid-cols-1 lg:grid-cols-2 gap-8">
          <total-blue-bar title="Total de despachos" :total="total_despachos" />
          <total-blue-bar
            icon="file"
            title="Total de documentos"
            :total="total_documentos"
          />
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-1 gap-8">
          <card
            class="rounded-xl blue-border min-h-12"
            title="Cantidad Despachos"
          >
            <cantidad-despachos
              v-if="
                fechas.length > 0 &&
                total.length > 0 &&
                exportacion.length > 0 &&
                importacion.length > 0
              "
              :fechas="fechas"
              :total="total"
              :exportacion="exportacion"
              :importacion="importacion"
            ></cantidad-despachos>
          </card>

          <!--
        <div
          class="flex flex-col w-full gap-8"
          @click="
            irADespachos({
              estado: true,
              text: 'Total Despachos',
              value: 'Mostrar Todos',
              filtro: 'total_despachos',
            })
          "
        ></div>
        -->

          <div class="grid grid-cols-3 gap-8 w-full">
            <estatus-despacho
              class="blue-border"
              titulo="Pendientes"
              color="#E65B38"
              :cantidad="despachos_pendientes"
            >
              <template slot="ver">
                <button
                  class="boton-ver"
                  @click="
                    irADespachos({
                      estado: true,
                      text: 'Estado Carga',
                      value: 'Pendiente',
                      filtro: 'despachos_pendientes',
                    })
                  "
                >
                  Ver
                </button>
              </template>
            </estatus-despacho>

            <estatus-despacho
              class="blue-border"
              titulo="Parcial"
              color="#02BE92"
              :cantidad="despachos_parcial"
            >
              <template slot="ver">
                <button
                  class="boton-ver"
                  @click="
                    irADespachos({
                      estado: true,
                      text: 'Estado Carga',
                      value: 'Parcial',
                      filtro: 'despachos_parcial',
                    })
                  "
                >
                  Ver
                </button>
              </template>
            </estatus-despacho>

            <estatus-despacho
              class="blue-border"
              titulo="Total"
              color="#5699F4"
              :cantidad="despachos_total"
            >
              <template slot="ver">
                <button
                  class="boton-ver"
                  @click="
                    irADespachos({
                      estado: true,
                      text: 'Estado Carga',
                      value: 'Total',
                      filtro: 'despachos_total',
                    })
                  "
                >
                  Ver
                </button>
              </template>
            </estatus-despacho>
          </div>

          <despachos-por-pedidor :data="despachos_por_pedidor" />
          <despachos-por-aduana :data="despachos_por_aduana" />
        </div>

        <div class="grid grid-cols-1 gap-8">
          <tipo-vistos-buenos
            :data="vistos_buenos_instituciones"
            :vistos_buenos="vistos_buenos"
            :irVistosBuenos="irVistosBuenos"
          />
          <tipo-aforos
            :data="aforos_tipos"
            :aforos="aforos"
            :irAforos="irAforos"
          />

          <fecha-eta
            :data="eta"
            :irADespachosPendientes="irADespachos"
            :irADespachosRealizados="irADespachos"
          >
            <template slot="ver">
              <button
                class="boton-ver"
                @click="
                  irADespachos({
                    estado: true,
                    text: 'Fecha ETA',
                    value: 'Fecha en Rango',
                    filtro: 'fecha_eta',
                  })
                "
              >
                Ver
              </button>
            </template>
          </fecha-eta>

          <card
            class="flex flex-col rounded-xl p-4 gap-8 h-100 blue-border"
            title="Documentos"
          >
            <div class="flex flex-col w-full items-center gap-8">
              <documentos-grafico
                v-if="
                  documentos_completos != null && documentos_faltantes != null
                "
                :data="p_estados"
              >
              </documentos-grafico>

              <documento-porsentaje-estado
                estado="Pendiente"
                :value="p_estados?.pendientes"
                @click="
                  irADespachos({
                    estado: true,
                    text: 'Estado Documentos',
                    value: 'Completos',
                    filtro: 'documentos_completos',
                  })
                "
              />
              <documento-porsentaje-estado
                estado="Presentado"
                :value="p_estados?.presentados"
                @click="
                  irADespachos({
                    estado: true,
                    text: 'Estado Documentos',
                    value: 'Completos',
                    filtro: 'documentos_completos',
                  })
                "
              />
              <documento-porsentaje-estado
                estado="Legalizado"
                :value="p_estados?.legalizados"
                @click="
                  irADespachos({
                    estado: true,
                    text: 'Estado Documentos',
                    value: 'Completos',
                    filtro: 'documentos_completos',
                  })
                "
              />
              <documento-porsentaje-estado
                estado="Retirado"
                :value="p_estados?.retirados"
                @click="
                  irADespachos({
                    estado: true,
                    text: 'Estado Documentos',
                    value: 'Completos',
                    filtro: 'documentos_completos',
                  })
                "
              />
            </div>
          </card>
        </div>
      </div>

      <b-modal :visible="isBusy" hide-footer hide-header hide-backdrop centered>
        <div class="h-full flex flex-row items-center justify-center">
          <b-spinner
            large
            style="width: 3rem; height: 3rem"
            class="text-primary"
          />
        </div>
      </b-modal>
    </div>
  </div>
</template>

<style scoped>
::v-deep(.modal-content) {
  width: 120px;
  height: 120px;
  border-radius: 12px;
}

::v-deep(.modal-dialog-centered) {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.title-dashboard p {
  color: #969393;
  text-transform: uppercase;
  font-weight: 500;
  font-size: 10px;

  text-align: left;
  margin-bottom: 0;
}

.title-dashboard .btn-dashboard:hover {
  border: none;
  background-color: #e65b38;
  color: white;
}
.filtro-activo {
  background-color: #e65b38 !important;
  color: white !important;
}

.botones-fecha {
  display: flex;
  justify-content: center;
  text-align: center;
}

.botones-fecha {
  margin-bottom: 20px;
  margin-top: 20px;
}

.botones-fecha p {
  color: #707070;
  font-weight: 600;
  font-size: 10px;

  text-align: left;
  margin-bottom: 0;
}

.botones-fecha .btn-dashboard {
  width: 80px;
  border-radius: 20px;
  border: none;
  background-color: white;
  color: #043161;
}
.botones-fecha .btn-dashboard:hover {
  border: none;
  background-color: #e65b38;
  color: white;
}

.documentos {
  cursor: pointer;
}
</style>
